import axios from '@/services/axios.js'
import type { Advertisement } from '@/types/advertisement'

export async function getActiveModal(): Promise<Advertisement | null> {
  const response = await axios.get<{ data: Advertisement | null }>(
    '/api/advertisement/modal'
  )
  return response.data?.data ?? null
}

export async function getActiveBanners(): Promise<Advertisement[]> {
  const response = await axios.get<{ data: Advertisement[] }>(
    '/api/advertisement/banners'
  )
  return response.data?.data ?? []
}
